import { createContext, useContext, useState, useEffect, useCallback } from 'react';
import { authAPI } from './api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUser = useCallback(async () => {
    const token = localStorage.getItem('pfc_token');
    if (!token) { setLoading(false); return; }
    try {
      const res = await authAPI.getMe();
      setUser(res.data.user);
    } catch {
      localStorage.removeItem('pfc_token');
      localStorage.removeItem('pfc_user');
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    // Skip auth check if returning from OAuth callback
    if (window.location.hash?.includes('session_id=')) {
      setLoading(false);
      return;
    }
    loadUser();
  }, [loadUser]);

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('pfc_token', res.data.token);
    localStorage.setItem('pfc_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const register = async (data) => {
    const res = await authAPI.register(data);
    localStorage.setItem('pfc_token', res.data.token);
    localStorage.setItem('pfc_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const logout = async () => {
    try { await authAPI.logout(); } catch (e) { console.error(e); }
    localStorage.removeItem('pfc_token');
    localStorage.removeItem('pfc_user');
    setUser(null);
  };

  const googleLogin = async (sessionId) => {
    const res = await authAPI.googleSession(sessionId);
    localStorage.setItem('pfc_token', res.data.token);
    localStorage.setItem('pfc_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    return res.data;
  };

  const refreshUser = async () => {
    try { const res = await authAPI.getMe(); setUser(res.data.user); } catch (e) { console.error(e); }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, refreshUser, googleLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
